import MuiButton, { ButtonProps as MuiButtonProps } from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

export type ButtonProps = MuiButtonProps & {
  component?: React.ElementType;
};

const Button = withStyles<'root', {}, ButtonProps>(
  (theme) => ({
    root: {
      // disable all the nice things
      borderRadius: 0,
      boxShadow: 'none'
    }
  }),
  { name: 'FdButton' }
)(MuiButton);

export default Button;
